module.exports = __webpack_public_path__ + "static/3-84bbea709dd1e9eb5dc9603b7c85b916.jpg";